// Compone la URL de Gmail (web) para redactar un correo. A diferencia de un
// link "mailto:", esto siempre abre algo (una pestaña del navegador) sin
// depender de que el usuario tenga una app de correo configurada como
// predeterminada en su sistema operativo.
export const buildGmailComposeUrl = (to: string, subject?: string): string => {
  const params = new URLSearchParams({ view: "cm", fs: "1", to });
  if (subject) params.set("su", subject);
  return `https://mail.google.com/mail/?${params.toString()}`;
};

export const MANAGEMENT_EMAIL = "managementdesafio@gmail.com";
